import React from "react";

export default function ColorChips({ colors }) {
  return (
    <ul className="color-list">
      {colors.map((c, i) => (
        <li key={i} className="color-chip">
          {c.hex && <span className="swatch" style={{ background: c.hex }} />}
          <span className="color-name">{c.name}</span>
        </li>
      ))}
    </ul>
  );
}
